import { Head, useForm } from "@inertiajs/react"

import { Button } from "@/components/ui/button"
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import {
  Field,
  FieldError,
  FieldGroup,
  FieldLabel,
} from "@/components/ui/field"
import { Input } from "@/components/ui/input"
import AuthLayout from "@/layouts/auth-layout"
import { adminPasswordPath } from "@/routes"

interface EditProps {
  reset_password_token: string
  email: string
}

export default function EditAdminPasswordReset({
  reset_password_token,
  email,
}: EditProps) {
  const { data, setData, put, processing, errors } = useForm({
    admin: {
      reset_password_token,
      password: "",
      password_confirmation: "",
    },
  })

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    put(adminPasswordPath())
  }

  return (
    <AuthLayout title="" description="">
      <Head title="Set new password" />
      <div className="flex w-full flex-col gap-6">
        <Card>
          <CardHeader className="text-center">
            <CardTitle className="text-xl">Set new password</CardTitle>
            <CardDescription>
              Enter a new password for your account
            </CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit}>
              <FieldGroup>
                <Field>
                  <FieldLabel htmlFor="email">Email</FieldLabel>
                  <Input
                    id="email"
                    type="email"
                    value={email}
                    readOnly
                    className="bg-muted"
                  />
                </Field>
                <Field>
                  <FieldLabel htmlFor="password">New password</FieldLabel>
                  <Input
                    id="password"
                    type="password"
                    name="admin[password]"
                    autoComplete="new-password"
                    placeholder="Enter new password"
                    value={data.admin.password}
                    onChange={(e) =>
                      setData("admin", {
                        ...data.admin,
                        password: e.target.value,
                      })
                    }
                    required
                    autoFocus
                  />
                  {errors["admin.password"] && (
                    <FieldError>{errors["admin.password"]}</FieldError>
                  )}
                </Field>
                <Field>
                  <FieldLabel htmlFor="password_confirmation">
                    Confirm password
                  </FieldLabel>
                  <Input
                    id="password_confirmation"
                    type="password"
                    name="admin[password_confirmation]"
                    autoComplete="new-password"
                    placeholder="Confirm new password"
                    value={data.admin.password_confirmation}
                    onChange={(e) =>
                      setData("admin", {
                        ...data.admin,
                        password_confirmation: e.target.value,
                      })
                    }
                    required
                  />
                  {errors["admin.password_confirmation"] && (
                    <FieldError>
                      {errors["admin.password_confirmation"]}
                    </FieldError>
                  )}
                </Field>
                <Field>
                  <Button type="submit" className="w-full" loading={processing}>
                    {processing ? "Resetting..." : "Reset password"}
                  </Button>
                </Field>
              </FieldGroup>
            </form>
          </CardContent>
        </Card>
      </div>
    </AuthLayout>
  )
}
